import { IOpenedStudentsRecord } from '../../../../store/dashboard/types';
import uniqBy from 'lodash/uniqBy';
import { Row } from '../types';
import { TagType, IStudentRow } from 'types';

export const serializeStudentsToRows = (
  students: IStudentRow[],
  openedStudentRecords: ReadonlyArray<IOpenedStudentsRecord>,
  onTagDelete: (tagId: string, tagType: TagType | undefined, row: Row) => void,
  currentUserName?: string,
): Row[] => {
  const params = new URLSearchParams(window.location.search);
  // Handle null/undefined students array gracefully
  if (!students || !Array.isArray(students)) {
    return [];
  }
  return uniqBy(students, 'p_key').map((student, idx) => {
    const row: Row = { ...student, idx };
    const openedRecord = openedStudentRecords.filter(
      record =>
        student.student_number === record.studentNumber && record.userName && record.userName !== currentUserName,
    );
    if (openedRecord.length > 0) {
      row.isOpened = true;
      const userNames = openedRecord.map(record => record.userName);
      row.openedBy = userNames;
    } else {
      row.isOpened = false;
      row.openedBy = undefined;
    }

    row['onTagDelete'] = onTagDelete;

    if (params.get('search')) {
      row.isSearch = true;
    }
    return row;
  });
};
